<template>
  <q-card :style="isDialog?(!$q.screen.lt.md?'width: 400px; max-width: 80vw;':''):''">
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <span>مدیریت گروه</span>
        <template v-slot:action>
          <q-btn icon="close" flat v-close-popup round/>
        </template>
      </q-banner>
    </q-card-section>
    <q-form @submit="onSubmit" autofocus>
      <q-card-section>
        <q-input v-model="localGroupObject.Group_Name"
                 filled
                 clearable
                 autofocus
                 label="عنوان گروه کالا"
                 :rules="[ val => val && val.length >= 3 || 'عنوان کالا الزامی و لازم است تعداد حروف بیشتر از 3 حرف باشد']"
        />
      </q-card-section>

     <q-card-actions>
       <q-btn label="تایید" type="submit" icon="search" color="primary"/>
       <q-btn label="انصراف" @click="localGroupObject.Group_Name=''"
              type="reset" icon="search_off" color="red" flat class="q-ml-sm" v-close-popup/>
     </q-card-actions>
    </q-form>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "GoodsGroupTree",
  props: {
    goodsGroupInfo: {
      type: Object
    },
    isDialog:{
      type:Boolean,
      required:false,
      default: true
    }
  },
  data() {
    return {
      localGroupObject: Object.assign({},this.goodsGroupInfo)
    }
  },
  methods: {
    ...mapActions({}),
    onSubmit() {
      this.$emit('changed-goods-group', this.localGroupObject)
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>